export default function CompanyOverview() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="flex-1 flex flex-col justify-center">
            <span className="inline-block text-xs font-medium text-foreground-500 uppercase tracking-widest border border-foreground-200/60 rounded-full px-3 py-1.5 mb-6 font-label whitespace-nowrap">
              Company Overview
            </span>

            <h2 className="text-4xl md:text-5xl font-bold text-foreground-950 leading-tight font-heading">
              Modern engineering
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold text-accent-600 leading-tight mt-2 font-heading italic">
              for the iOS platform
            </h3>

            <p className="mt-10 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl font-body">
              The team follows modern software engineering practices, including clean architecture,
              performance optimization, and user-centered design. Every system is built with an
              emphasis on scalability, maintainability, and rigorous technical standards that
              ensure reliable and future-ready solutions.
            </p>

            <p className="mt-8 text-base text-foreground-700 font-medium font-body border-b-2 border-accent-400/60 inline-block pb-1">
              Technical excellence through disciplined engineering
            </p>
          </div>

          <div className="flex-1 relative">
            <div className="flex justify-end gap-8 mb-10">
              <div className="text-right">
                <span className="block text-5xl md:text-6xl font-bold text-foreground-950 font-heading">100%</span>
                <span className="block text-xs text-foreground-500 uppercase tracking-wider mt-1 font-label">iOS Focus</span>
              </div>
            </div>

            <div className="relative h-[400px] md:h-[480px]">
              <div className="absolute top-0 left-4 w-[200px] h-[200px] md:w-[240px] md:h-[240px] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20architectural%20diagram%20with%20soft%20gradient%20fields%20transitioning%20from%20warm%20cream%20to%20pale%20beige%2C%20faint%20circular%20grid%20overlay%20pattern%20suggesting%20technical%20precision%2C%20clean%20minimal%20composition%20without%20any%20recognizable%20objects%20or%20text%2C%20subtle%20depth%20through%20layered%20translucent%20shapes%2C%20editorial%20quality%20abstract%20art%2C%20soft%20diffused%20lighting%2C%20warm%20neutral%20palette%2C%20balanced%20centered%20composition%2C%20delicate%20geometric%20linework%20intersecting%20at%20precise%20points%2C%20high%20resolution%20minimalist%20abstraction&width=400&height=400&seq=advnet-overview-card1&orientation=squarish"
                  alt="Abstract architectural diagram with circular grid overlay"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-0 right-4 w-[220px] h-[320px] md:w-[280px] md:h-[380px] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20architectural%20visualization%20with%20layered%20rectangular%20panels%20and%20subtle%20grid%20overlays%2C%20soft%20warm%20gradient%20from%20cream%20to%20light%20beige%2C%20circular%20compass-like%20geometric%20elements%20faintly%20visible%2C%20clean%20minimal%20composition%20suggesting%20technical%20diagrams%20without%20specific%20references%2C%20no%20text%20no%20people%20no%20products%2C%20editorial%20quality%20abstract%20art%2C%20diffused%20natural%20lighting%2C%20harmonious%20warm%20neutral%20tones%2C%20precise%20geometric%20linework%20with%20delicate%20transparency%2C%20architectural%20precision%20aesthetic%2C%20high%20resolution%20fine%20art%20abstraction&width=400&height=550&seq=advnet-overview-card2&orientation=portrait"
                  alt="Abstract layered rectangular panels with subtle grid patterns"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}